import axios from "axios";
import { serverAddress } from "../../constant";
import cookie from "js-cookie";

const Feedbackipem = {
  //get all feedback

  //total Ad-enquiry
  getAllStudentFeedback: (params) => {
    let url =
      serverAddress +
      `/student_feedback/get-all?page=${params.page}&limit=${params.limit}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },
  getOneStudentFeedback: (params) => {
    let url = serverAddress + `/student_feedback/get?id=${params}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },
  getAllFacultyFeedback: (params) => {
    let url =
      serverAddress +
      `/faculty_feedback/get-all?page=${params.page}&limit=${params.limit}`;
    return axios.get(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },
  getOneFacultyFeedback: (params) => {
    let url = serverAddress + `/faculty_feedback/get?id=${params}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },
  getAllEmployerFeedback: (params) => {
    let url =
      serverAddress +
      `/employer_feedback/get-all?page=${params.page}&limit=${params.limit}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },
  getOneEmployerFeedback: (params) => {
    let url = serverAddress + `/employer_feedback/get?id=${params}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },
  getAllAlumniFeedback: (params) => {
    let url =
      serverAddress +
      `/alumni_feedback/get-all?page=${params.page}&limit=${params.limit}`;
    return axios.get(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },
  getOneAlumniFeedback: (params) => {
    let url = serverAddress + `/alumni_feedback/get?id=${params}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  getAllParentFeedback: (params) => {
    let url =
      serverAddress +
      `/parent_feedback/get-all?page=${params.page}&limit=${params.limit}`;
    return axios.get(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  getOneParentFeedback: (params) => {
    let url = serverAddress + `/parent_feedback/get?id=${params}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  getAllStudentSatisfactionFeedback: (params) => {
    let url =
      serverAddress +
      `/student_satisfaction/get-all?page=${params.page}&limit=${params.limit}`;
    return axios.get(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  getAllSubjectFeedback:()=>{
    let url = `http://localhost:4001/ipem/subject_feedback`
  
    return axios.get(url)

  },
  getOneStudentSatisfaction:(params)=>{
    let url = serverAddress + `/student_satisfaction/get?id=${params}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },
  countTotatlEnquiry: () => {
    let url = serverAddress + `/website/enquiry/get/total/enquiry/popup`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  //total Ad-enquiry
  countAdEnquiry: () => {
    let url = serverAddress + `/website/enquiry/get/total/enquiry/ad`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  //total popup enquiry
  popupEnquiry: () => {
    let url = serverAddress + `/website/enquiry/get/total/enquiry/popup`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },
  //get total count of enquiry
  countTotatlEnquiry: () => {
    let url = serverAddress + `/website/enquiry/get/total/enquiry/popup`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });
  },

  ///dynamic filter ipem
  dynamicFilter: (params, page, limit) => {
    const x = JSON.stringify(params);
    const data = JSON.parse(x);

    let url;
    if (
      data.filter((obj) => {
        if (
          obj.field === "feedbackType" &&
          obj.selected.includes("student_feedback")
        ) {
          url =
            serverAddress +
            `/student_feedback/filter/dynamic?page=${page}&limit=${limit}`;
        }
        if (
          obj.field === "feedbackType" &&
          obj.selected.includes("faculty_feedback")
        ) {
          url =
            serverAddress +
            `/Faculty_feedback/filter/dynamic?page=${page}&limit=${limit}`;
        }
        if (
          obj.field === "feedbackType" &&
          obj.selected.includes("employer_feedback")
        ) {
          url =
            serverAddress +
            `/Employer_feedback/filter/dynamic?page=${page}&limit=${limit}`;
        }
        if (
          obj.field === "feedbackType" &&
          obj.selected.includes("alumni_feedback")
        ) {
          url =
            serverAddress +
            `/alumni_feedback/filter/dynamic?page=${page}&limit=${limit}`;
        }
        if (
          obj.field === "feedbackType" &&
          obj.selected.includes("parent_feedback")
        ) {
          url =
            serverAddress +
            `/parent_feedback/filter/dynamic?page=${page}&limit=${limit}`;
        }
        if (
          obj.field === "feedbackType" &&
          obj.selected.includes("student_satisfaction")
        ) {
          url =
            serverAddress +
            `/student_satisfaction/filter/dynamic?page=${page}&limit=${limit}`;
        }

        if (
          obj.field === "feedbackType" &&
          obj.selected.includes("student_satisfaction")
        ) {
          url =
            serverAddress +
            `/student_satisfaction/filter/dynamic?page=${page}&limit=${limit}`;
        }
      })
    )
      // console.log(params);
      return axios.post(url, params, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${cookie.get("ajwt")}`,
        },
      });
  },

  //download dynamic filter ipem
  ///dynamic filter ipem
  downloadDynamicFilter: (params, page, limit) => {
    let url =
      serverAddress +
      `/website/enquiry/filter/ExportDynamic?page=${page}&limit=${limit}`;
    return axios.post(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
      responseType: "blob",
    });
  },

  // search ipem Filter Integration
  searchQuery: (params, page, limit, category) => {
    console.log(category);
    if(category=='student_feedback'){
      let url =
      serverAddress + `/student_feedback/search-student?page=${page}&limit=${limit}`;
    return axios.post(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });

    }
   else if(category=='alumni_feedback'){
      let url =
      serverAddress + `/alumni_feedback/search-alumni?page=${page}&limit=${limit}`;
    return axios.post(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });

    }
    else if(category=='employer_feedback'){
      let url =
      serverAddress + `/employer_feedback/search-employer?page=${page}&limit=${limit}`;
    return axios.post(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });

    }
    else if(category=='faculty_feedback'){
      let url =
      serverAddress + `/faculty_feedback/search-faculty?page=${page}&limit=${limit}`;
    return axios.post(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });

    }
    else if(category=='parent_feedback'){
      let url =
      serverAddress + `/parent_feedback/search-parent?page=${page}&limit=${limit}`;
    return axios.post(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });

    }
    else if(category=='student_satisfaction'){
      let url =
      serverAddress + `/student_satisfaction/search-studentsatisfaction?page=${page}&limit=${limit}`;
    return axios.post(url, params, {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: `Bearer ${cookie.get("ajwt")}`,
      },
    });

    }

  },
};

export default Feedbackipem;
